module.exports = __webpack_public_path__ + "img/graph-line-grey.4a14a4e3.svg";